var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$slots.default)?_c('div',{staticClass:"mt-1 text-sm",class:_vm.hintClass},[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }